import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InventoryService } from 'src/app/ceq/inventory/inventory.service';
import { SettingsService } from 'src/app/core/settings/settings.service';
import { EmployeeService } from 'src/app/ceq/catalog/employee/employee.service';
import { CarrierService } from '../carrier.service';
import { CarrierModel } from 'src/app/ceq/common/models/Carrier.Model';
import { UserLogin } from 'src/app/ceq/common/models/UserLogin.Model';
import { Employee } from 'src/app/ceq/common/models/Employee.Model';
import { Unit } from 'src/app/ceq/common/models/Unit.Model';
import { GlobalFunctionsService } from 'src/app/ceq/common/functions/global-functions.service';

@Component({
  selector: 'app-carrier-detail',
  templateUrl: './carrier-detail.component.html',
  styleUrls: ['./carrier-detail.component.scss']
})
export class CarrierDetailComponent implements OnInit {

  carrier: CarrierModel = new CarrierModel();
  userLogin: UserLogin;
  isNew: boolean = false;
  units: Unit[] = [];
  employees: Employee[] = [];
  selectedUnit: string = "";
  selectedEmployee: string = "";
  searchEmployeeField = 'EmployeeName';
  searchUnitField = 'UnitDescription';

  constructor(
    private url: ActivatedRoute,
    private settings: SettingsService,
    private carrierService: CarrierService,
    private employeeService: EmployeeService,
    private globalFunctionService: GlobalFunctionsService,
    private inventoryService: InventoryService
  ) { }

  ngOnInit(): void {
    this.userLogin = this.settings.getUser();
    const currentId = this.url.snapshot.paramMap.get('id');
    this.carrier.Org = this.userLogin.Org;

    if (this.isNullOrWhitespace(currentId) || currentId === 'create') {
      this.isNew = true;
      this.fillCombos();
    } else {
      this.isNew = false;
      this.carrier.EmployeeCode = currentId;
      this.getFiscalConfig();
    }
  }

  fillCombos() {
    // Carga paralela de catálogos
    this.employeeService.GetEmployeesByUnitId(this.userLogin.UnitId, "", 0).subscribe(data => {
      this.employees = data;
      if (!this.isNew && this.carrier.EmployeeCode) {
        const emp = this.employees.find(x => x.EmployeeCode === this.carrier.EmployeeCode);
        this.selectedEmployee = emp ? emp.EmployeeName : this.carrier.EmployeeCode;
      }
    });

    this.inventoryService.getAllFactoryCeve().subscribe((data: Unit[]) => {
      this.units = data;
      const unitIdToFind = this.isNew ? this.userLogin.UnitId : this.carrier.UnitId;
      const unit = this.units.find(x => x.UnitId === unitIdToFind);
      
      if (unit) {
        this.selectedUnit = unit.UnitDescription;
        this.carrier.UnitId = unit.UnitId;
      }
    });
  }

  getFiscalConfig() {
    this.carrierService.getCarrierById(this.carrier.EmployeeCode).subscribe({
      next: (data) => {
        this.carrier = data;
        this.fillCombos();
      },
      error: async () => {
        await this.globalFunctionService.messageBimbo("No se encontró el vehículo solicitado", 'warning', '¡Alerta!');
        this.btnCancelOnClick();
      }
    });
  }

  formSubmit() {
    const operation = this.isNew 
      ? this.carrierService.createCarrier(this.carrier)
      : this.carrierService.updateCarrier(this.carrier);

    operation.subscribe({
      next: async () => {
        const msg = this.isNew ? 'Vehículo creado' : 'Vehículo actualizado';
        await this.globalFunctionService.messageBimbo(msg, 'success', '¡Éxito!');
        this.btnCancelOnClick();
      },
      error: async (err) => {
        await this.globalFunctionService.messageBimbo(err.error || 'Error en la operación', 'error', '¡Error!');
      }
    });
  }

  btnCancelOnClick() {
    window.close();
  }

  changeEmployee(event: Employee): void {
    this.carrier.EmployeeCode = event.EmployeeCode;
  }

  changeUnit(event: Unit): void {
    this.carrier.UnitId = event.UnitId;
  }

  private isNullOrWhitespace(input: any): boolean {
    return !input || input.toString().trim().length < 1;
  }
}